import { Controller } from "@hotwired/stimulus";
import YoutubePlayer from "youtube-player";
export default class extends Controller {
  static values = {
    link: String,
    initialSeek: Number,
    seekPause: true,
    shouldInitPlayer: true,
  };
  static targets = ["linkInput", "videoPlayer"];

  connect() {
    this.playerElement = this.hasVideoPlayerTarget
      ? this.videoPlayerTarget
      : this.element.querySelector("#video-player");
    this.playerElementWrapper = this.playerElement.parentElement;
    if (this.shouldInitPlayerValue) {
      this.initPlayer();
    }
    this.currentSeek = this.initialSeekValue;
    this.isPlayerShown = true;
    if (this.linkValue) {
      this.loadVideo(this.linkValue);
    } else {
      this.hidePlayer();
    }
  }

  initPlayer() {
    if (this.player) {
      return;
    }

    const player = YoutubePlayer(this.playerElement.id);
    this.player = player;
  }

  hidePlayer() {
    this.playerElementWrapper.classList.add("hidden");
    this.isPlayerShown = false;
  }

  showPlayer() {
    this.playerElementWrapper.classList.remove("hidden");
    this.isPlayerShown = true;
  }

  loadVideo(raw_url) {
    const url = new URL(raw_url);
    const videoId =
      new URLSearchParams(url.search).get("v") ||
      url.pathname.split("?")[0].split("/").pop();
    if (this.currentVideoId && this.currentVideoId == videoId) {
      return;
    }
    this.currentVideoId = videoId;
    this.initPlayer();
    this.player.loadVideoById(videoId, this.currentSeek || 0);

    this.player.pauseVideo();
    if (this.seekPauseValue) {
      this.player.playVideo();
      this.player.on("stateChange", (event) => {
        if (event.data === 1) {
          this.player.pauseVideo();
        }
      });
    }
  }

  disconnect() {
    if (this.player) this.player.destroy();
  }

  seekPrev() {
    this.seek(-1);
  }

  seekNext() {
    this.seek(1);
  }

  seekSkip() {
    this.seek(5);
  }

  seek(second) {
    const player = this.player;
    if (!player) return;

    this.currentSeek += second;
    player.seekTo(this.currentSeek, true);
    player.playVideo();
  }

  openStageSlect() {
    const element = this.element.querySelector(
      'label[for="extract_clear_data_from_video_job_stage_id"]'
    );
    element.click();
    element.scrollIntoView();
  }

  assignCurrentTimestamp() {
    const url = new URL(this.linkInputTarget.value);
    const videoId = new URLSearchParams(url.search).get("v");
    this.linkInputTarget.value = `https://youtube.com/watch?v=${videoId}&t=${this.currentSeek}s`;
  }

  embedNewVideo(event) {
    const link = event.params.link || this.linkInputTarget.value;
    if (!link.match(/http.*youtube.*watch\?v=/)) {
      this.hidePlayer();
      return false;
    }
    this.showPlayer();
    this.loadVideo(link);
  }

  togglePlayer(event) {
    if (this.isPlayerShown) {
      this.hidePlayer();
    } else if (this.player) {
      this.showPlayer();
    } else {
      this.embedNewVideo(event);
    }
  }

  triggerSubmit() {
    this.element.querySelector("form").submit();
  }
}
